export default `# Template Catalog

Session templates define the structure and flow of a session. Browse existing templates or create your own.

---

## Browsing Templates

The table shows all available templates with sortable columns:

| Column | Description |
|--------|-------------|
| Name | Template identity |
| Category | Workshop, Brainstorm, Review, Planning, or Custom |
| Scope | Session, User, or Organization |
| Status | Draft, Pending Review, Approved, or Rejected |
| Phases | Number of phases in the template |
| Usage | How many sessions have used this template |
| Version | Iteration number |

A **Default** badge marks the template used when no other is selected.

### Filtering
- **Search** by name or description
- **Scope filter** — Session, User, or Organization
- **Category filter** — Narrow by template type
- **Prebuilt only** — Show only system-provided templates

---

## Template Actions

| Action | Description |
|--------|-------------|
| Eye icon | Preview the template structure |
| Edit icon | Open in the Template Builder |
| Copy icon | Clone with a new name |
| Send icon | Submit for review (draft only) |
| Delete icon | Remove (draft only) |

---

## Creating Templates

Click **Create Template** to open the builder, a 3-step wizard:

1. **Basic Information** — Name, description, purpose, goal, category, and scope
2. **Phase Selection** — Search the Phase Library and add phases in order. Drag to reorder.
3. **Review & Create** — Confirm everything and save

At least one phase is required. Phases execute in the order you arrange them.

---

## Phase Library

Click **Phase Library** to browse and manage reusable phase definitions. Phases are the building blocks of templates — each defines a segment of the session (e.g. "Intros", "Brainstorming", "Decision Review").

---

## Publishing Workflow

Same as avatars:
1. **Draft** → 2. **Pending Review** → 3. **Approved** or **Rejected**

Submit to Organisation or System scope with optional change notes.

---

## Tips

- **Start from a prebuilt template** — Clone it and customise rather than building from scratch
- **Check usage counts** — Popular templates are battle-tested and likely to work well
- **Keep phases focused** — Each phase should have a clear goal. Broad phases are harder to facilitate
- **Preview before using** — Always preview a template before running a session with it`;
